import { useNavigate } from 'react-router-dom';
import '../styles/EmployeeMaster.css';
import SubDeptTable from '../components/SubDeptTable';

const SubDept = () => {
     const navigate = useNavigate();

     const handleAddClick = () => {
          navigate('/subdept/add');
     };

     return (
          <div className="employee-master-page">
               <div className="employee-header">
                    <h2>Sub Department Master</h2>
                    <button className="add-employee-btn" onClick={handleAddClick}>
                         Add Sub Department
                    </button>
               </div>

               <SubDeptTable />
          </div>
     );
};

export default SubDept;